var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"100","persistent":"","content-class":"loading-dialog"},model:{value:(_vm.showLoading),callback:function ($$v) {_vm.showLoading=$$v},expression:"showLoading"}},[_c('v-card',[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"accent"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }